/* Upsell product detail page */

// --- Start Product Upsell Variant Logic (Moved from Liquid) ---
// This entire block is wrapped in jQuery(document).ready to ensure execution 
// only after the deferred jQuery library is loaded.

jQuery(document).ready(function ($) {

    // --- LANGUAGE SETUP ---
    // Get the current language code from the HTML tag
    const languageCode = document.documentElement.getAttribute("lang");

    let addToCartText = 'In den Warenkorb'; // Default to German
    let soldOutText = 'Ausverkauft';       // Default to German
    let saveText = 'du sparst';           // Default to German
    
    // Check if the language is explicitly English or non-German
    if (languageCode && languageCode.startsWith("en")) {
        addToCartText = 'Add to Cart';
        soldOutText = 'Sold Out';
        saveText = 'You save';
    } else if (languageCode && !languageCode.startsWith("de")) {
         // Fallback for other non-German languages
         addToCartText = 'Add to Cart';
         soldOutText = 'Sold Out';
         saveText = 'You save';
    }
    // ---------------------------------
    
    // --- CURRENCY SETUP ---
    // Reads the global variable defined in Liquid (You MUST have: window.currencySymbol = '{{ cart.currency.symbol }}'; in your theme.liquid)
    const currencySymbol = window.currencySymbol || '€'; 
    // ----------------------

    // --- MOBILE SELECT TOGGLE LOGIC ---
    $('.select-for-mobile-only-custom').on('click', function () {
        $(this).toggleClass('active');
    });
    // ----------------------------------
    
    // --- ATC-UPSELL-2-CUSTOM HANDLER ---
    // Moved to assets/upsell-add-to-cart.js. It used to click the form's submit button,
    // which fell through to a full page POST /cart/add whenever <product-form> had not
    // upgraded yet, producing "Required parameter missing or invalid: items".
    // -----------------------------------


    // Function to update available options based on current selections
    function updateAvailableOptions(productForm) {
      const productJson = productForm.dataset.productJson;
      if (!productJson) { return; }
      let productData;
      try { productData = JSON.parse(productJson); } catch (error) { return; }

      const selectedOptions = [];
      productData.options.forEach((option, index) => {
        const selectedButton = productForm.querySelector(
          `.option-group[data-option-index="${index}"] .option-button.selected`
        );
        selectedOptions.push(selectedButton ? selectedButton.dataset.value : '');
      });

      productData.options.forEach((option, optionIndex) => {
        const optionButtons = productForm.querySelectorAll(
          `.option-group[data-option-index="${optionIndex}"] .option-button`
        );
        optionButtons.forEach((button) => {
          const value = button.dataset.value;
          let isAvailable = false;

          if (optionIndex === 0) {
            isAvailable = productData.variants.some((variant) => {
              return variant.options[optionIndex] === value && variant.available;
            });
          } else {
            const matchingVariants = productData.variants.filter((variant) => {
              return (
                variant.options[optionIndex] === value &&
                selectedOptions.every((selectedValue, selectedIndex) => {
                  return selectedIndex === optionIndex || variant.options[selectedIndex] === selectedValue;
                })
              );
            });
            isAvailable = matchingVariants.some((variant) => variant.available);
          }

          if (isAvailable) {
            button.classList.remove('unavailable');
            button.style.textDecoration = 'none';
            button.style.cursor = 'pointer';
          } else {
            button.classList.add('unavailable');
            button.style.textDecoration = 'line-through';
            button.style.cursor = 'not-allowed';
          }
        });
      });
    }

    // Function to update variant ID, image, and price based on selected options (FIXED CURRENCY & LANG)
    function updateVariantIdImageAndPrice(productForm) {
      if (!productForm.dataset.productJson) { return; }
      let productData;
      try { productData = JSON.parse(productForm.dataset.productJson); } catch (error) { return; }

      const selectedOptions = [];
      productData.options.forEach((option, index) => {
        const selectedButton = productForm.querySelector(
          `.option-group[data-option-index="${index}"] .option-button.selected`
        );
        selectedOptions.push(selectedButton ? selectedButton.dataset.value : '');
      });

      const matchingVariant = productData.variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      const productItem = productForm.closest('.product-item-upsell');
      if (!productItem) { return; }

      const imageElement = productItem.querySelector('.product-image img');
      const addToCartButton = productForm.querySelector('.add-to-cart-button');
      const soldOutBadge = productForm.querySelector('.sold-out-badge');
      const priceElement = productItem.querySelector('.product-price');
      const comparePriceElement = productItem.querySelector('.product-compare-price');
      const priceouter = productItem.querySelector('.product-item-upsell .price-info');
      const saveElement = productItem.querySelector('.product-save');
      const button2 = productItem.querySelector('.atc-upsell-2-custom');

      if (matchingVariant) {
        const variantIdInput = productForm.querySelector('.variant-id');
        if (variantIdInput) { variantIdInput.value = matchingVariant.id; }

        if (
          matchingVariant.featured_media &&
          matchingVariant.featured_media.preview_image &&
          matchingVariant.featured_media.preview_image.src
        ) {
          if (imageElement) { imageElement.src = matchingVariant.featured_media.preview_image.src; }
        }

        if (priceElement) {
          priceElement.textContent = `${(matchingVariant.price / 100).toFixed(2)}${currencySymbol}`;
          priceouter.style.visibility = 'visible';
        }

        if (comparePriceElement && saveElement) {
          if (matchingVariant.compare_at_price > matchingVariant.price) {
            comparePriceElement.textContent = `${(matchingVariant.compare_at_price / 100).toFixed(
              2
            )}${currencySymbol}`;
            
            saveElement.textContent = `${saveText} ${(
              (matchingVariant.compare_at_price - matchingVariant.price) /
              100
            ).toFixed(2)}${currencySymbol}`;
            
            comparePriceElement.style.display = 'inline';
            saveElement.style.display = 'inline';
            priceouter.style.visibility = 'visible';
          } else {
            comparePriceElement.style.display = 'none';
            saveElement.style.display = 'none';
            priceouter.style.visibility = 'visible';
          }
        }

        if (addToCartButton) {
          if (matchingVariant.available) {
            addToCartButton.textContent = addToCartText;
            addToCartButton.disabled = false;
            if (soldOutBadge) { soldOutBadge.style.display = 'none'; }
          } else {
            addToCartButton.textContent = soldOutText;
            addToCartButton.disabled = true;
            if (soldOutBadge) { soldOutBadge.style.display = 'inline'; }
          }
        }
        
        if (button2) {
          if (matchingVariant.available) {
            button2.textContent = addToCartText;
            button2.disabled = false;
            if (soldOutBadge) { soldOutBadge.style.display = 'none'; }
          } else {
            button2.textContent = soldOutText;
            button2.disabled = true;
            if (soldOutBadge) { soldOutBadge.style.display = 'inline'; }
          }
        }
      } else {
        const variantIdInput = productForm.querySelector('.variant-id');
        if (variantIdInput) { variantIdInput.value = ''; }

        if (priceElement) {
          priceElement.textContent = `${(productData.price / 100).toFixed(2)}${currencySymbol}`;
        }

        if (comparePriceElement) { comparePriceElement.style.display = 'none'; }
        if (saveElement) { saveElement.style.display = 'none'; }

        if (addToCartButton) {
          addToCartButton.textContent = soldOutText;
          addToCartButton.disabled = true;
          if (soldOutBadge) { soldOutBadge.style.display = 'inline'; }
        }
      }

      updateAvailableOptions(productForm);
    }

    // Function to initialize product forms and add event listeners
    function initializeProductForms() {
      document.querySelectorAll('.product-form').forEach((productForm) => {
        productForm.querySelectorAll('.option-button').forEach((button) => {
          button.addEventListener('click', function () {
            const optionGroup = button.closest('.option-group');
            if (optionGroup) {
              optionGroup.querySelectorAll('.option-button').forEach((btn) => btn.classList.remove('selected'));
              button.classList.add('selected');
              updateVariantIdImageAndPrice(productForm);

              const selectedVariantValue = optionGroup.querySelector('.selected-variant-value');
              if (selectedVariantValue) { selectedVariantValue.textContent = button.dataset.value; }
              const selectedVariantValue2 = optionGroup.querySelector('.selected-variant-value-2');
              if (selectedVariantValue2) { selectedVariantValue2.textContent = button.dataset.value; }
            }
          });
        });
        
        // Initial State Update
        updateVariantIdImageAndPrice(productForm); 
      });
      
      // Apply translation to static "sold out" badge
      document.querySelectorAll('.product-item-upsell .sold-out-badge').forEach(badge => {
          if (badge.textContent.trim() === 'Ausverkauft') {
             badge.textContent = soldOutText;
          }
      });
    }

    // Execute the initialization function when jQuery is ready
    initializeProductForms();
});

// --- End Product Upsell Variant Logic ---